// eslint-disable-next-line import/no-anonymous-default-export
export default {
    "New chat": {
        translationEng: "New chat",
        translationJp: "新しいチャット",
        translationIn: "Percakapan Baru",
        translationSl: "නව කතාබස්",
        translationNp: "नयाँ कुराकानी",
        translationVn: "Trò chuyện mới",
        translationPh: "Bagong chat",
        translationBd: "নতুন চ্যাট"
    },
    "We value your feedback": {
        translationEng: "We value your feedback",
        translationJp: "ご意見をお聞かせください",
        translationIn: "Kami menghargai masukan Anda",
        translationSl: "ඔබේ අදහස් අපට වැදගත්ය",
        translationNp: "हामी तपाईंको प्रतिक्रिया कदर गर्छौं",
        translationVn: "Chúng tôi trân trọng phản hồi của bạn",
        translationPh: "Pinahahalagahan namin ang iyong feedback",
        translationBd: "আমরা আপনার মতামতকে মূল্য দিই"
    },
    "Submit Feedback": {
        translationEng: "Submit Feedback",
        translationJp: "フィードバックを送信する",
        translationIn: "Ajukan Masukan",
        translationSl: "ප්‍රතිචාර ඉදිරිපත් කරන්න",
        translationNp: "प्रतिक्रिया पेश गर्नुहोस्",
        translationVn: "Gửi phản hồi",
        translationPh: "Isumite ang Feedback",
        translationBd: "মতামত জমা দিন"
    },
    "Post": {
        translationEng: "Post",
        translationJp: "投稿",
        translationIn: "Kirim",
        translationSl: "පළ කරන්න",
        translationNp: "पोस्ट गर्नुहोस्",
        translationVn: "Đăng",
        translationPh: "I-post",
        translationBd: "পোস্ট করুন"
    },
    "Mandatory": {
        translationEng: "Mandatory",
        translationJp: "必須",
        translationIn: "Wajib",
        translationSl: "අනිවාර්යයි",
        translationNp: "अनिवार्य",
        translationVn: "Bắt buộc",
        translationPh: "Obligado",
        translationBd: "আবশ্যক"
    },
    "Optional": {
        translationEng: "Optional",
        translationJp: "任意",
        translationIn: "Opsional",
        translationSl: "විකල්ප",
        translationNp: "वैकल्पिक",
        translationVn: "Tùy chọn",
        translationPh: "Opsyonal",
        translationBd: "ঐচ্ছিক"
    },
    "PDF or image": {
        translationEng: "PDF or image",
        translationJp: "PDFまたは画像",
        translationIn: "PDF atau gambar",
        translationSl: "PDF හෝ රූපය",
        translationNp: "PDF वा तस्बिर",
        translationVn: "PDF hoặc hình ảnh",
        translationPh: "PDF o larawan",
        translationBd: "পিডিএফ বা ছবি"
    },
    "Attachment": {
        translationEng: "Attachment",
        translationJp: "添付ファイル",
        translationIn: "Lampiran",
        translationSl: "ඇමුණුම",
        translationNp: "संलग्नक",
        translationVn: "Tệp đính kèm",
        translationPh: "Kalakip",
        translationBd: "সংযুক্তি"
    },
    "Only PDF, PNG and JPG files are allowed": {
        translationEng: "Only PDF, PNG and JPG files are allowed",
        translationJp: "PDF、PNG、JPGファイルのみ使用できます",
        translationIn: "Hanya file PDF, PNG, dan JPG yang diizinkan",
        translationSl: "PDF, PNG සහ JPG ගොනු පමණක් අනුමතයි",
        translationNp: "PDF, PNG र JPG फाइलहरू मात्र अनुमति छ",
        translationVn: "Chỉ cho phép tệp PDF, PNG và JPG",
        translationPh: "PDF, PNG at JPG na file lamang ang pinapayagan",
        translationBd: "শুধুমাত্র PDF, PNG এবং JPG ফাইল অনুমোদিত"
    },
    "File is too large": {
        translationEng: "File is too large",
        translationJp: "ファイルサイズが大きすぎます",
        translationIn: "Ukuran file terlalu besar",
        translationSl: "ගොනුව ඉතා විශාලයි",
        translationNp: "फाइल धेरै ठूलो छ",
        translationVn: "Tệp quá lớn",
        translationPh: "Masyadong malaki ang file",
        translationBd: "ফাইলটি খুব বড়"
    },
    "Describe your problem": {
        translationEng: "Describe your problem",
        translationJp: "問題の詳細を",
        translationIn: "Silakan jelaskan permasalahan Anda",
        translationSl: "ඔබගේ ගැටලුව විස්තර කරන්න",
        translationNp: "आफ्नो समस्या वर्णन गर्नुहोस्",
        translationVn: "Mô tả vấn đề của bạn",
        translationPh: "Ilarawan ang iyong problema",
        translationBd: "আপনার সমস্যাটি বর্ণনা করুন"
    },
    "How can I assist you today?": {
        translationEng: "How can I assist you today?",
        translationJp: "本日はどのようなご用件でしょうか？",
        translationIn: "Bagaimana saya dapat membantu Anda hari ini?",
        translationSl: "මම අද ඔබට කෙසේ උදව් කළ හැකිද?",
        translationNp: "म म आज तपाईंलाई कसरी सहयोग गर्न सक्छु?",
        translationVn: "Tôi có thể giúp gì cho bạn hôm nay?",
        translationPh: "Paano kita matutulungan ngayon?",
        translationBd: "আমি আজ কীভাবে আপনাকে সাহায্য করতে পারি?"
    },
    "Welcome to the TIC Chatbot Portal": {
        translationEng: "Welcome to the TIC Chatbot Portal",
        translationJp: "TICチャットボットポータルへようこそ",
        translationIn: "Selamat datang di Portal Chatbot TIC",
        translationSl: "TIC චැට්බොට් පෝර්ටලයට සාදරයෙන් පිළිගනිමු",
        translationNp: "TIC च्याटबोट पोर्टलमा स्वागत छ",
        translationVn: "Chào mừng đến với Cổng Chatbot TIC",
        translationPh: "Maligayang pagdating sa TIC Chatbot Portal",
        translationBd: "TIC চ্যাটবট পোর্টালে স্বাগতম"
    },
    "Fuso truck diagnostics, service and repair — expert answers in seconds.": {
        translationEng: "Fuso truck diagnostics, service and repair — expert answers in seconds.",
        translationJp: "ふそうトラックの診断・整備・修理 — 専門的な回答を数秒で。",
        translationIn: "Diagnosis, servis, dan perbaikan truk Fuso — jawaban ahli dalam hitungan detik.",
        translationSl: "Fuso ට්‍රක් රෝග විනිශ්චය, සේවා සහ අලුත්වැඩියාව — තත්පර කිහිපයකින් විශේෂඥ පිළිතුරු.",
        translationNp: "फुसो ट्रक निदान, सर्भिस र मर्मत — केही सेकेन्डमै विशेषज्ञ जवाफहरू।",
        translationVn: "Chẩn đoán, bảo dưỡng và sửa chữa xe tải Fuso — câu trả lời chuyên gia trong vài giây.",
        translationPh: "Diagnostic, serbisyo at pagkumpuni ng trak na Fuso — ekspertong sagot sa loob ng ilang segundo.",
        translationBd: "ফুসো ট্রাক ডায়াগনস্টিক, সার্ভিস ও মেরামত — কয়েক সেকেন্ডে বিশেষজ্ঞ উত্তর।"
    },
    "Fetching Information": {
        translationEng: "Fetching Information",
        translationJp: "情報を取得中",
        translationIn: "Mengambil informasi",
        translationSl: "තොරතුරු ලබා ගනිමින්",
        translationNp: "जानकारी ल्याउँदै",
        translationVn: "Đang lấy thông tin",
        translationPh: "Kinukuha ang impormasyon",
        translationBd: "তথ্য আনা হচ্ছে"
    },
    "Generating": {
        translationEng: "Generating",
        translationJp: "回答を作成中",
        translationIn: "Membuat jawaban",
        translationSl: "පිළිතුර සකසමින්",
        translationNp: "उत्तर तयार गर्दै",
        translationVn: "Đang tạo câu trả lời",
        translationPh: "Binubuo ang sagot",
        translationBd: "উত্তর তৈরি হচ্ছে"
    },
    "Formatting Cases": {
        translationEng: "Formatting Cases",
        translationJp: "事例を整理中",
        translationIn: "Menyusun kasus",
        translationSl: "සිද්ධි සකස් කරමින්",
        translationNp: "केसहरू मिलाउँदै",
        translationVn: "Đang sắp xếp các trường hợp",
        translationPh: "Inaayos ang mga kaso",
        translationBd: "কেসগুলি সাজানো হচ্ছে"
    },
    "Verifying Answer": {
        translationEng: "Verifying Answer",
        translationJp: "回答を確認中",
        translationIn: "Memeriksa jawaban",
        translationSl: "පිළිතුර තහවුරු කරමින්",
        translationNp: "उत्तर जाँच गर्दै",
        translationVn: "Đang kiểm tra câu trả lời",
        translationPh: "Sinusuri ang sagot",
        translationBd: "উত্তর যাচাই করা হচ্ছে"
    },
    "Fetching Manual Pages": {
        translationEng: "Fetching Manual Pages",
        translationJp: "整備解説書のページを取得中",
        translationIn: "Mengambil halaman manual",
        translationSl: "අත්පොත් පිටු ලබා ගනිමින්",
        translationNp: "म्यानुअल पृष्ठहरू ल्याउँदै",
        translationVn: "Đang lấy các trang sổ tay",
        translationPh: "Kinukuha ang mga pahina ng manual",
        translationBd: "ম্যানুয়াল পৃষ্ঠা আনা হচ্ছে"
    },
    "Fetching Images": {
        translationEng: "Fetching Images",
        translationJp: "画像を取得中",
        translationIn: "Mengambil gambar",
        translationSl: "රූප ලබා ගනිමින්",
        translationNp: "तस्बिरहरू ल्याउँदै",
        translationVn: "Đang lấy hình ảnh",
        translationPh: "Kinukuha ang mga larawan",
        translationBd: "ছবি আনা হচ্ছে"
    },
    "No matching past cases found": {
        translationEng: "No matching past cases found",
        translationJp: "該当する過去事例は見つかりませんでした",
        translationIn: "Tidak ditemukan kasus lama yang sesuai",
        translationSl: "ගැළපෙන පැරණි සිද්ධි හමු නොවීය",
        translationNp: "मिल्दो पुराना केस भेटिएन",
        translationVn: "Không tìm thấy trường hợp trước đây phù hợp",
        translationPh: "Walang nakitang katugmang nakaraang kaso",
        translationBd: "মিলে যাওয়া কোনো পুরোনো কেস পাওয়া যায়নি"
    },
    "Vehicle (Model Codes)": {
        translationEng: "Vehicle (Model Codes)",
        translationJp: "車両（モデルコード）",
        translationIn: "Kendaraan (Kode Model)",
        translationSl: "වාහනය (මාදිලි කේත)",
        translationNp: "सवारी (मोडेल कोड)",
        translationVn: "Xe (Mã model)",
        translationPh: "Sasakyan (Mga Model Code)",
        translationBd: "যানবাহন (মডেল কোড)"
    },
    "Model Year": {
        translationEng: "Model Year",
        translationJp: "年式",
        translationIn: "Tahun Model",
        translationSl: "මාදිලි වර්ෂය",
        translationNp: "मोडेल वर्ष",
        translationVn: "Năm model",
        translationPh: "Taon ng Model",
        translationBd: "মডেল বছর"
    },
    "Manual No.": {
        translationEng: "Manual No.",
        translationJp: "整備解説書番号",
        translationIn: "No. Manual",
        translationSl: "අත්පොත් අංකය",
        translationNp: "म्यानुअल नं.",
        translationVn: "Số sổ tay",
        translationPh: "Numero ng Manual",
        translationBd: "ম্যানুয়াল নং"
    },
    "Volumes": {
        translationEng: "Volumes",
        translationJp: "巻",
        translationIn: "Jilid",
        translationSl: "වෙළුම්",
        translationNp: "खण्डहरू",
        translationVn: "Các tập",
        translationPh: "Mga Tomo",
        translationBd: "খণ্ডসমূহ"
    },
    "Emission Reg. Code": {
        translationEng: "Emission Reg. Code",
        translationJp: "排出ガス規制記号",
        translationIn: "Kode Regulasi Emisi",
        translationSl: "විමෝචන රෙගුලාසි කේතය",
        translationNp: "उत्सर्जन नियमन कोड",
        translationVn: "Mã quy định khí thải",
        translationPh: "Emission Regulation Code",
        translationBd: "নিঃসরণ বিধি কোড"
    },
    "Chassis No. (From)": {
        translationEng: "Chassis No. (From)",
        translationJp: "車台番号（開始）",
        translationIn: "No. Rangka (Mulai)",
        translationSl: "චැසි අංකය (සිට)",
        translationNp: "च्यासिस नं. (देखि)",
        translationVn: "Số khung (Từ)",
        translationPh: "Numero ng Chassis (Mula)",
        translationBd: "চ্যাসিস নং (থেকে)"
    },
    "First Issued": {
        translationEng: "First Issued",
        translationJp: "初版発行",
        translationIn: "Pertama Terbit",
        translationSl: "පළමු නිකුතුව",
        translationNp: "पहिलो पटक जारी",
        translationVn: "Phát hành lần đầu",
        translationPh: "Unang Inilabas",
        translationBd: "প্রথম প্রকাশ"
    },
    "Remarks": {
        translationEng: "Remarks",
        translationJp: "備考",
        translationIn: "Catatan",
        translationSl: "සටහන්",
        translationNp: "कैफियत",
        translationVn: "Ghi chú",
        translationPh: "Mga Tala",
        translationBd: "মন্তব্য"
    },
    "Heavy Duty Bus": {
        translationEng: "Heavy Duty Bus",
        translationJp: "大型バス",
        translationIn: "Bus Tugas Berat",
        translationSl: "බර බස්",
        translationNp: "हेभी ड्युटी बस",
        translationVn: "Xe buýt hạng nặng",
        translationPh: "Heavy Duty na Bus",
        translationBd: "হেভি ডিউটি বাস"
    },
    "Heavy Duty Trucks": {
        translationEng: "Heavy Duty Trucks",
        translationJp: "大型トラック",
        translationIn: "Truk Tugas Berat",
        translationSl: "බර ට්‍රක්",
        translationNp: "हेभी ड्युटी ट्रक",
        translationVn: "Xe tải hạng nặng",
        translationPh: "Heavy Duty na Trak",
        translationBd: "হেভি ডিউটি ট্রাক"
    },
    "Light Duty Bus": {
        translationEng: "Light Duty Bus",
        translationJp: "小型バス",
        translationIn: "Bus Tugas Ringan",
        translationSl: "සැහැල්ලු බස්",
        translationNp: "लाइट ड्युटी बस",
        translationVn: "Xe buýt hạng nhẹ",
        translationPh: "Light Duty na Bus",
        translationBd: "লাইট ডিউটি বাস"
    },
    "Light Duty Trucks": {
        translationEng: "Light Duty Trucks",
        translationJp: "小型トラック",
        translationIn: "Truk Tugas Ringan",
        translationSl: "සැහැල්ලු ට්‍රක්",
        translationNp: "लाइट ड्युटी ट्रक",
        translationVn: "Xe tải hạng nhẹ",
        translationPh: "Light Duty na Trak",
        translationBd: "লাইট ডিউটি ট্রাক"
    },
    "Medium Duty Trucks": {
        translationEng: "Medium Duty Trucks",
        translationJp: "中型トラック",
        translationIn: "Truk Tugas Menengah",
        translationSl: "මධ්‍යම ට්‍රක්",
        translationNp: "मिडियम ड्युटी ट्रक",
        translationVn: "Xe tải hạng trung",
        translationPh: "Medium Duty na Trak",
        translationBd: "মিডিয়াম ডিউটি ট্রাক"
    },
    "Thinking": {
        translationEng: "Thinking",
        translationJp: "考え中",
        translationIn: "Sedang berpikir",
        translationSl: "සිතමින්",
        translationNp: "सोच्दै",
        translationVn: "Đang suy nghĩ",
        translationPh: "Nag-iisip",
        translationBd: "ভাবছে"
    },
    "Please select a model before proceeding.": {
        translationEng: "Please select a model before proceeding.",
        translationJp: "続行する前にモデルを選択してください。",
        translationIn: "Silakan pilih model sebelum melanjutkan.",
        translationSl: "ඉදිරියට යාමට පෙර කරුණාකර ආකෘතියක් තෝරන්න.",
        translationNp: "अगाडि बढ्नुअघि कृपया एउटा मोडेल चयन गर्नुहोस्।",
        translationVn: "Vui lòng chọn một mẫu xe trước khi tiếp tục.",
        translationPh: "Mangyaring pumili ng modelo bago magpatuloy.",
        translationBd: "অনুগ্রহ করে এগিয়ে যাওয়ার আগে একটি মডেল নির্বাচন করুন।"
    },
    "Select Model": {
        translationEng: "Select Vehicle Model",
        translationJp: "車両モデルを選択",
        translationIn: "Pilih Model Kendaraan",
        translationSl: "වාහන ආකෘතිය තෝරන්න",
        translationNp: "सवारीसाधन मोडेल छान्नुहोस्",
        translationVn: "Chọn Mẫu Xe",
        translationPh: "Piliin ang Modelo ng Sasakyan",
        translationBd: "যানবাহনের মডেল নির্বাচন করুন"
    },
    "Select Engine": {
        translationEng: "Select Engine",
        translationJp: "エンジンを選択します。",
        translationIn: "Pilih Mesin",
        translationSl: "ඉන්ජිම තෝරන්න",
        translationNp: "इन्जिन चयन गर्नुहोस्",
        translationVn: "Chọn động cơ",
        translationPh: "Piliin ang Engine",
        translationBd: "ইঞ্জিন নির্বাচন করুন"
    }
    ,
    "Help us shape a better experience by sharing your feedback!": {
        translationEng: "Help us shape a better experience by sharing your feedback!",
        translationJp: "ご意見・ご感想をお聞かせください",
        translationIn: "Bantu kami menciptakan pengalaman yang lebih baik dengan membagikan masukan Anda!",
        translationSl: "ඔබගේ අදහස් බෙදා ගෙන හොඳ අත්දැකීමක් ඇති කිරීමට උදව් කරන්න!",
        translationNp: "आफ्नो प्रतिक्रिया साझा गरेर राम्रो अनुभव बनाउन हामीलाई मद्दत गर्नुहोस्!",
        translationVn: "Giúp chúng tôi cải thiện trải nghiệm bằng cách chia sẻ phản hồi của bạn!",
        translationPh: "Tulungan kaming bumuo ng mas mahusay na karanasan sa pamamagitan ng pagbabahagi ng iyong feedback!",
        translationBd: "আপনার মতামত শেয়ার করে আমাদের উন্নত অভিজ্ঞতা গড়তে সাহায্য করুন!"
    },
    "Add information to database": {
        translationEng: "Add information to database",
        translationJp: "データベースに情報を追加します",
        translationIn: "Tambahkan informasi ke basis data",
        translationSl: "දත්ත සමුදායට තොරතුරු එකතු කරන්න",
        translationNp: "डाटाबेसमा जानकारी थप्नुहोस्",
        translationVn: "Thêm thông tin vào cơ sở dữ liệu",
        translationPh: "Magdagdag ng impormasyon sa database",
        translationBd: "ডাটাবেসে তথ্য যোগ করুন"
    },
    "Case study of repair and troubleshooting": {
        translationEng: "Case study of repair and troubleshooting",
        translationJp: "修理・トラブルシューティング事例",
        translationIn: "Studi kasus perbaikan dan pemecahan masalah",
        translationSl: "අලුත්වැඩියා සහ ගැටලු විසඳීමේ නඩු අධ්‍යයනය",
        translationNp: "मर्मत र समस्या समाधानको केस अध्ययन",
        translationVn: "Nghiên cứu tình huống sửa chữa và xử lý sự cố",
        translationPh: "Case study ng pagkukumpuni at troubleshooting",
        translationBd: "মেরামত এবং ট্রাবলশুটিং এর কেস স্টাডি"
    },
    "Please describe the reason for this repair in as much detail as possible.": {
        translationEng: "Please describe the reason for this repair in as much detail as possible.",
        translationJp: "※この修理を実施した理由を出来るだけ詳細に記載ください。",
        translationIn: "Silakan jelaskan alasan perbaikan ini sedetail mungkin.",
        translationSl: "කරුණාකර මෙම අලුත්වැඩියාව සිදු කිරීමට හේතුව හැකි තරම් විස්තරාත්මකව විස්තර කරන්න.",
        translationNp: "कृपया यो मर्मत गर्नुको कारण सकेसम्म विस्तृत रूपमा वर्णन गर्नुहोस्।",
        translationVn: "Vui lòng mô tả chi tiết nhất có thể lý do thực hiện sửa chữa này.",
        translationPh: "Mangyaring ilarawan nang detalyado hangga't maaari ang dahilan ng pagkukumpuning ito.",
        translationBd: "অনুগ্রহ করে এই মেরামতের কারণ যতটা সম্ভব বিস্তারিত বর্ণনা করুন।"
    },
    "Vehicle model": {
        translationEng: "Vehicle model",
        translationJp: "車両モデル",
        translationIn: "Model kendaraan",
        translationSl: "වාහන ආකෘතිය",
        translationNp: "सवारीसाधन मोडेल",
        translationVn: "Mẫu xe",
        translationPh: "Modelo ng sasakyan",
        translationBd: "যানবাহনের মডেল"
    },
    "Issue summary": {
        translationEng: "Issue summary",
        translationJp: "不具合概要",
        translationIn: "Ringkasan masalah",
        translationSl: "ගැටලු සාරාංශය",
        translationNp: "समस्या सारांश",
        translationVn: "Tóm tắt sự cố",
        translationPh: "Buod ng isyu",
        translationBd: "সমস্যার সারসংক্ষেপ"
    },
    "Repair details": {
        translationEng: "Repair details",
        translationJp: "修理内容",
        translationIn: "Detail perbaikan",
        translationSl: "අලුත්වැඩියා විස්තර",
        translationNp: "मर्मत विवरण",
        translationVn: "Chi tiết sửa chữa",
        translationPh: "Detalye ng pagkukumpuni",
        translationBd: "মেরামতের বিবরণ"
    },
    "Reason": {
        translationEng: "Reason",
        translationJp: "理由",
        translationIn: "Alasan",
        translationSl: "හේතුව",
        translationNp: "कारण",
        translationVn: "Lý do",
        translationPh: "Dahilan",
        translationBd: "কারণ"
    },
    "Enter your feedback": {
        translationEng: "Enter your feedback",
        translationJp: "フィードバックを伺ってもよろしいでしょうか？",
        translationIn: "Masukkan masukan Anda",
        translationSl: "ඔබේ ප්‍රතිචාර ඇතුළත් කරන්න",
        translationNp: "आफ्नो प्रतिक्रिया प्रविष्ट गर्नुहोस्",
        translationVn: "Nhập phản hồi của bạn",
        translationPh: "Ilagay ang iyong feedback",
        translationBd: "আপনার মতামত লিখুন"
    }
    ,
    "Close": {
        translationEng: "Close",
        translationJp: "クローズ",
        translationIn: "Tutup",
        translationSl: "වසන්න",
        translationNp: "बन्द गर्नुहोस्",
        translationVn: "Đóng",
        translationPh: "Isara",
        translationBd: "বন্ধ করুন"
    },
    "Submit": {
        translationEng: "Submit",
        translationJp: "投稿します",
        translationIn: "Kirim",
        translationSl: "ඉදිරිපත් කරන්න",
        translationNp: "पेश गर्नुहोस्",
        translationVn: "Gửi đi",
        translationPh: "Isumite",
        translationBd: "জমা দিন"
    }
    ,
    "Submitting feedback": {
        translationEng: "Submitting feedback",
        translationJp: "フィードバックを送信中",
        translationIn: "Mengirim masukan",
        translationSl: "ප්‍රතිචාර යැවෙමින් පවතී",
        translationNp: "प्रतिक्रिया पेश गर्दै",
        translationVn: "Đang gửi phản hồi",
        translationPh: "Isinusumite ang feedback",
        translationBd: "মতামত জমা দেওয়া হচ্ছে"
    },
    "Submitting information": {
        translationEng: "Submitting information",
        translationJp: "情報を送信中",
        translationIn: "Mengirim informasi",
        translationSl: "තොරතුරු යොමු වෙමින් පවතී",
        translationNp: "जानकारी पेश गर्दै",
        translationVn: "Đang gửi thông tin",
        translationPh: "Isinusumite ang impormasyon",
        translationBd: "তথ্য জমা দেওয়া হচ্ছে"
    },
    "Please wait": {
        translationEng: "Please wait",
        translationJp: "少々お待ちください",
        translationIn: "Mohon tunggu",
        translationSl: "කරුණාකර රැඳී සිටින්න",
        translationNp: "कृपया पर्खनुहोस्",
        translationVn: "Vui lòng chờ",
        translationPh: "Paki hintay",
        translationBd: "অনুগ্রহ করে অপেক্ষা করুন"
    },
    "Feedback submitted": {
        translationEng: "Feedback submitted",
        translationJp: "フィードバックが送信されました",
        translationIn: "Masukan berhasil dikirim",
        translationSl: "ප්‍රතිචාර යැවීම සම්පූර්ණයි",
        translationNp: "प्रतिक्रिया पेश गरिएको छ",
        translationVn: "Phản hồi đã được gửi",
        translationPh: "Naisumite na ang feedback",
        translationBd: "মতামত জমা দেওয়া হয়েছে"
    },
    "Information submitted": {
        translationEng: "Information submitted",
        translationJp: "情報が送信されました",
        translationIn: "Informasi berhasil dikirim",
        translationSl: "තොරතුරු යොමු කිරීම සම්පූර්ණයි",
        translationNp: "जानकारी पेश गरिएको छ",
        translationVn: "Thông tin đã được gửi",
        translationPh: "Naisumite na ang impormasyon",
        translationBd: "তথ্য জমা দেওয়া হয়েছে"
    },
    "Thank you for your feedback!": {
        translationEng: "Thank you for your feedback!",
        translationJp: "フィードバックをありがとうございます！",
        translationIn: "Terima kasih atas masukan Anda!",
        translationSl: "ඔබේ ප්‍රතිචාර සඳහා ස්තුතියි!",
        translationNp: "तपाईंको प्रतिक्रियाको लागि धन्यवाद!",
        translationVn: "Cảm ơn bạn đã phản hồi!",
        translationPh: "Salamat sa iyong feedback!",
        translationBd: "আপনার মতামতের জন্য ধন্যবাদ!"
    }
    ,
    "Thank you for your contribution!": {
        translationEng: "Thank you for your contribution!",
        translationJp: "ご提供ありがとうございます！",
        translationIn: "Terima kasih atas kontribusi Anda!",
        translationSl: "ඔබගේ දායකත්වයට ස්තුතියි!",
        translationNp: "तपाईंको योगदानको लागि धन्यवाद!",
        translationVn: "Cảm ơn bạn vì sự đóng góp của bạn!",
        translationPh: "Salamat sa iyong kontribusyon!",
        translationBd: "আপনার অবদানের জন্য ধন্যবাদ!"
    },
    "Submission failed": {
        translationEng: "Submission failed",
        translationJp: "送信に失敗しました",
        translationIn: "Pengiriman gagal",
        "translationSl": "ඉදිරිපත් කිරීම අසාර්ථක විය",
        "translationNp": "पेश गर्न असफल भयो",
        "translationVn": "Gửi thất bại",
        "translationPh": "Nabigo ang pagsusumite",
        "translationBd": "জমা দিতে ব্যর্থ হয়েছে"
    },
    "Something went wrong. Please try again.": {
        translationEng: "Something went wrong. Please try again.",
        translationJp: "何か問題が発生しました。もう一度お試しください。",
        translationIn: "Terjadi kesalahan. Mohon coba lagi.",
        "translationSl": "යමක් වැරදී ඇත. නැවත උත්සාහ කරන්න.",
        "translationNp": "केही गलत भयो। कृपया पुनः प्रयास गर्नुहोस्।",
        "translationVn": "Đã xảy ra lỗi. Vui lòng thử lại.",
        "translationPh": "May nangyaring mali. Pakiulit.",
        "translationBd": "কিছু ভুল হয়েছে। অনুগ্রহ করে আবার চেষ্টা করুন।"
    },
    "Delete": {
        translationEng: "Delete",
        translationJp: "削除します。",
        translationIn: "Hapus",
        translationSl: "මකන්න",
        translationNp: "हटाउनुहोस्",
        translationVn: "Xóa",
        translationPh: "Tanggalin",
        translationBd: "মুছুন"
    },
    "Are you sure you want to delete this chat?": {
        translationEng: "Are you sure you want to delete this chat?",
        translationJp: "このチャットを削除してもよろしいでしょうか？",
        translationIn: "Apakah Anda yakin ingin menghapus percakapan ini?",
        translationSl: "ඔබට මෙම කතාබස් මකන්න අවශ්‍ය බව විශ්වාසද?",
        translationNp: "के तपाईं यो कुराकानी मेटाउन चाहनुहुन्छ?",
        translationVn: "Bạn có chắc chắn muốn xóa cuộc trò chuyện này không?",
        translationPh: "Sigurado ka bang gusto mong tanggalin ang chat na ito?",
        translationBd: "আপনি কি নিশ্চিতভাবে এই চ্যাটটি মুছে ফেলতে চান?"
    },
    "Logout": {
        translationEng: "Logout",
        translationJp: "ログアウト",
        translationIn: "Keluar",
        translationSl: "පිටවෙන්න",
        translationNp: "लग आउट गर्नुहोस्",
        translationVn: "Đăng xuất",
        translationPh: "Mag-logout",
        translationBd: "লগ আউট"
    },
    "Select Language": {
        translationEng: "Select Language",
        translationJp: "言語を選択します。",
        translationIn: "Pilih Bahasa",
        translationSl: "භාෂාව තෝරන්න",
        translationNp: "भाषा चयन गर्नुहोस्",
        translationVn: "Chọn ngôn ngữ",
        translationPh: "Piliin ang Wika",
        translationBd: "ভাষা নির্বাচন করুন"
    },
    "Close Sidebar": {
        translationEng: "Close Sidebar",
        translationJp: "サイドバーを閉じます。",
        translationIn: "Tutup Sidebar",
        translationSl: "ඉවතලන්න පැති තීරුව",
        translationNp: "साइडबार बन्द गर्नुहोस्",
        translationVn: "Đóng thanh bên",
        translationPh: "Isara ang Sidebar",
        translationBd: "সাইডবার বন্ধ করুন"
    },
    "Copy": {
        translationEng: "Copy",
        translationJp: "コピー",
        translationIn: "Salin",
        translationSl: "පිටපත් කරන්න",
        translationNp: "प्रतिलिपि गर्नुहोस्",
        translationVn: "Sao chép",
        translationPh: "Kopyahin",
        translationBd: "কপি করুন"
    },
    "Save response": {
        translationEng: "Save response",
        translationJp: "対応を保存します。",
        translationIn: "Simpan jawaban",
        translationSl: "ප්‍රතිචාර සුරකින්න",
        translationNp: "जवाफ सुरक्षित गर्नुहोस्",
        translationVn: "Lưu phản hồi",
        translationPh: "I-save ang sagot",
        translationBd: "উত্তর সংরক্ষণ করুন"
    },
    "Bad response": {
        translationEng: "Bad response",
        translationJp: "悪い対応",
        translationIn: "Jawaban buruk",
        translationSl: "නරක පිළිතුරක්",
        translationNp: "खराब प्रतिक्रिया",
        translationVn: "Phản hồi tệ",
        translationPh: "Masamang sagot",
        translationBd: "খারাপ উত্তর"
    },
    "Good response": {
        translationEng: "Good response",
        translationJp: "良い対応",
        translationIn: "Jawaban baik",
        translationSl: "හොඳ පිළිතුරක්",
        translationNp: "राम्रो प्रतिक्रिया",
        translationVn: "Phản hồi tốt",
        translationPh: "Magandang sagot",
        translationBd: "ভাল উত্তর"
    },
    "Deleting Chat": {
        translationEng: "Deleting Chat",
        translationJp: "チャットは削除中です。",
        translationIn: "Menghapus Percakapan",
        translationSl: "කතාබස් මකාදැමීම සිදුවෙමින් පවතී",
        translationNp: "कुराकानी हटाइँदैछ",
        translationVn: "Đang xóa cuộc trò chuyện",
        translationPh: "Binubura ang chat",
        translationBd: "চ্যাট মুছে ফেলা হচ্ছে"
    },
    "Chat Deleted": {
        translationEng: "Chat Deleted",
        translationJp: "チャットは削除されました",
        translationIn: "Percakapan Dihapus",
        translationSl: "කතාබස් මකා දමා ඇත",
        translationNp: "कुराकानी मेटिएको छ",
        translationVn: "Đã xóa cuộc trò chuyện",
        translationPh: "Natanggal ang chat",
        translationBd: "চ্যাট মুছে ফেলা হয়েছে"
    },
    "Chat Deleted successfully!": {
        translationEng: "Chat Deleted successfully!",
        translationJp: " チャットは正常に削除されました！",
        translationIn: "Percakapan Berhasil Dihapus!",
        translationSl: "කතාබස් සාර්ථකව මකාදමා ඇත!",
        translationNp: "कुराकानी सफलतापूर्वक मेटियो!",
        translationVn: "Đã xóa cuộc trò chuyện thành công!",
        translationPh: "Matagumpay na natanggal ang chat!",
        translationBd: "চ্যাট সফলভাবে মুছে ফেলা হয়েছে!"
    },
    "Today": {
        translationEng: "Today",
        translationJp: "今日",
        translationIn: "Hari ini",
        translationSl: "අද",
        translationNp: "आज",
        translationVn: "Hôm nay",
        translationPh: "Ngayon",
        translationBd: "আজ"
    },
    "Yesterday": {
        translationEng: "Yesterday",
        translationJp: "昨日",
        translationIn: "Kemarin",
        translationSl: "ඊයේ",
        translationNp: "हिजो",
        translationVn: "Hôm qua",
        translationPh: "Kahapon",
        translationBd: "গতকাল"
    },
    "Last 7 Days": {
        translationEng: "Last 7 Days",
        translationJp: "過去7日間 ",
        translationIn: "7 Hari Terakhir",
        translationSl: "පසුගිය දින 7ක්",
        translationNp: "पछिल्ला ७ दिन",
        translationVn: "7 ngày qua",
        translationPh: "Huling 7 araw",
        translationBd: "গত ৭ দিন"
    },
    "Last 30 Days": {
        translationEng: "Last 30 Days",
        translationJp: "過去30日間",
        translationIn: "30 Hari Terakhir",
        translationSl: "පසුගිය දින 30ක්",
        translationNp: "पछिल्ला ३० दिन",
        translationVn: "30 ngày qua",
        translationPh: "Huling 30 araw",
        translationBd: "গত ৩০ দিন"
    },
    "Read aloud": {
        translationEng: "Read aloud",
        translationJp: "読み上げ",
        translationIn: "Baca dengan suara keras",
        translationSl: "මුඛයෙන් කියවන්න",
        translationNp: "ठूलो स्वरमा पढ्नुहोस्",
        translationVn: "Đọc to",
        translationPh: "Basahin ng malakas",
        translationBd: "উচ্চস্বরে পড়ুন"
    },
    "loading": {
        translationEng: "Loading",
        translationJp: "読み込み中",
        translationIn: "memuat",
        translationSl: "පූරණය වෙමින් පවතී",
        translationNp: "लोड हुँदैछ",
        translationVn: "Đang tải",
        translationPh: "Naglo-load",
        translationBd: "লোড হচ্ছে"
    },
    "stop": {
        translationEng: "Stop",
        translationJp: "停止",
        translationIn: "Berhenti",
        translationSl: "නවත්වන්න",
        translationNp: "रोक्नुहोस्",
        translationVn: "Dừng lại",
        translationPh: "Itigil",
        translationBd: "থামুন"
    },
    "Feedback created": {
        translationEng: "Feedback created",
        translationJp: "フィードバックが作成されました",
        translationIn: "Masukan dibuat",
        translationSl: "ප්‍රතිචාර සාදන ලදී",
        translationNp: "प्रतिक्रिया सिर्जना गरिएको छ",
        translationVn: "Phản hồi đã được tạo",
        translationPh: "Nagawa ang feedback",
        translationBd: "মতামত তৈরি হয়েছে"
    },
    "Feedback Shared Successfully": {
        translationEng: "Feedback Shared Successfully",
        translationJp: "フィードバックが正常に共有されました",
        translationIn: "Masukan Berhasil Dibagikan",
        translationSl: "ප්‍රතිචාර සාර්ථකව බෙදාගනු ලැබීය",
        translationNp: "प्रतिक्रिया सफलतापूर्वक साझा गरियो",
        translationVn: "Phản hồi đã được chia sẻ thành công",
        translationPh: "Matagumpay na naibahagi ang feedback",
        translationBd: "মতামত সফলভাবে ভাগ করা হয়েছে"
    },
    "success": {
        translationEng: "Success",
        translationJp: "成功しました",
        translationIn: "Berhasil",
        translationSl: "සාර්ථකයි",
        translationNp: "सफलता",
        translationVn: "Thành công",
        translationPh: "Tagumpay",
        translationBd: "সফলতা"
    },
    "24/7 Availability": {
        translationEng: "24/7 Availability",
        translationJp: "24/7の対応",
        translationIn: "Tersedia 24/7",
        translationSl: "දින 24 පැය 7ක් ලබා ගත හැකියි",
        translationNp: "२४/७ उपलब्धता",
        translationVn: "Sẵn có 24/7",
        translationPh: "Magagamit 24/7",
        translationBd: "২৪/৭ উপলব্ধ"
    },
    "Instant Response": {
        translationEng: "Instant Response",
        translationJp: "即時応答",
        translationIn: "Respon Instan",
        translationSl: "ක්ෂණික ප්‍රතිචාර",
        translationNp: "तत्काल प्रतिक्रिया",
        translationVn: "Phản hồi tức thì",
        translationPh: "Agarang Tugon",
        translationBd: "তাৎক্ষণিক প্রতিক্রিয়া"
    },
    "Consistency": {
        translationEng: "Consistency",
        translationJp: "一貫性のある応答",
        translationIn: "Konsistensi",
        translationSl: "සංසන්දනය",
        translationNp: "संगति",
        translationVn: "Tính nhất quán",
        translationPh: "Pagkakapare-pareho",
        translationBd: "ধারাবাহিকতা"
    },
    "Scalability": {
        translationEng: "Scalability",
        translationJp: "拡張性",
        translationIn: "Skalabilitas",
        translationSl: "විශාල කිරීමේ හැකියාව",
        translationNp: "विस्तारशीलता",
        translationVn: "Khả năng mở rộng",
        translationPh: "Naaangkop sa paglaki",
        translationBd: "স্কেলেবিলিটি"
    },
    "TIC Chatbots provide round-the-clock support.": {
        translationEng: "TIC Chatbots provide round-the-clock support.",
        translationJp: "TICチャットボットは、24時間365日サポートを提供します。",
        translationIn: "Chatbot TIC menyediakan dukungan sepanjang waktu.",
        translationSl: "TIC චැට්බොට් 24/7 සහය ලබා දෙයි.",
        translationNp: "TIC च्याटबोटले २४/७ सहयोग प्रदान गर्दछ।",
        translationVn: "TIC Chatbots cung cấp hỗ trợ suốt ngày đêm.",
        translationPh: "Nagbibigay ng suporta 24/7 ang TIC Chatbots.",
        translationBd: "TIC চ্যাটবট ২৪/৭ সাপোর্ট প্রদান করে।"
    },
    "Deliver immediate replies to user inquiries.": {
        translationEng: "Deliver immediate replies to user inquiries.",
        translationJp: "ユーザーの問い合わせに即座に返信します。",
        translationIn: "Memberikan tanggapan langsung terhadap pertanyaan pengguna.",
        translationSl: "පරිශීලක විමසුම්වලට ක්ෂණික පිළිතුරු ලබා දෙන්න.",
        translationNp: "प्रयोगकर्ताका जिज्ञासामा तत्काल जवाफ दिनुहोस्।",
        translationVn: "Đưa ra phản hồi ngay lập tức cho câu hỏi của người dùng.",
        translationPh: "Magbigay ng agarang tugon sa mga tanong ng user.",
        translationBd: "ব্যবহারকারীর প্রশ্নের তাৎক্ষণিক উত্তর প্রদান করুন।"
    },
    "Provide consistent responses & follow scripts.": {
        translationEng: "Provide consistent responses & follow scripts.",
        translationJp: "一貫した応答を提供し、スクリプトに従います。",
        translationIn: "Memberikan respons yang konsisten dan mengikuti skrip.",
        translationSl: "සංසන්දනීය පිළිතුරු ලබා දෙමින් ලිඛිත ක්‍රමවේද අනුව ක්‍රියා කරන්න.",
        translationNp: "संगत जवाफहरू दिनुहोस् र स्क्रिप्टहरू पालना गर्नुहोस्।",
        translationVn: "Cung cấp câu trả lời nhất quán và theo kịch bản.",
        translationPh: "Magbigay ng pare-parehong mga tugon at sundin ang mga script.",
        translationBd: "একই ধরনের উত্তর প্রদান করুন এবং স্ক্রিপ্ট অনুসরণ করুন।"
    },
    "Handle numerous interactions simultaneously.": {
        translationEng: "Handle numerous interactions simultaneously.",
        translationJp: "多数のやり取りを同時に処理します。",
        translationIn: "Menangani banyak interaksi secara bersamaan.",
        translationSl: "එක් වතාවකට බහු සංවාද කළමනාකරණය කරන්න.",
        translationNp: "धेरै अन्तरक्रियाहरूलाई एकै साथ व्यवस्थापन गर्नुहोस्।",
        translationVn: "Xử lý nhiều tương tác đồng thời.",
        translationPh: "Hawakan ang maraming pakikipag-ugnayan nang sabay-sabay.",
        translationBd: "একসাথে একাধিক ইন্টারঅ্যাকশন পরিচালনা করুন।"
    },
    "Login with Microsoft": {
        translationEng: "Login with Microsoft",
        translationJp: "",
        translationIn: "Masuk dengan Microsoft",
        translationSl: "Microsoft සමඟ පිවිසෙන්න",
        translationNp: "Microsoft सँग लग इन गर्नुहोस्",
        translationVn: "Đăng nhập bằng Microsoft",
        translationPh: "Mag-login gamit ang Microsoft",
        translationBd: "Microsoft দিয়ে লগইন করুন"
    },
    "Select Year": {
        translationEng: "Select Year",
        translationJp: "年度を選択",
        translationIn: "Pilih Tahun",
        translationSl: "වර්ෂය තෝරන්න",
        translationNp: "बर्ष चयन गर्नुहोस्",
        translationVn: "Chọn năm",
        translationPh: "Pumili ng Taon",
        translationBd: "বছর নির্বাচন করুন"
    },
    "Select the year of the maintenance manual": {
        translationEng: "Select the year of the maintenance manual",
        translationJp: "整備解説書の年度を選択",
        translationIn: "Pilih tahun buku panduan perawatan.",
        translationSl: "නඩත්තුවේ මාර්ගෝපදේශය සඳහා වසර තෝරන්න",
        translationNp: "रखरखाव म्यानुअलको वर्ष चयन गर्नुहोस्",
        translationVn: "Chọn năm của sổ tay bảo trì",
        translationPh: "Piliin ang taon ng maintenance manual",
        translationBd: "রক্ষণাবেক্ষণ ম্যানুয়ালের বছর নির্বাচন করুন"
    },
    "Quick suggestions": {
        translationEng: "Quick suggestions",
        translationJp: "クイック提案",
        translationIn: "Saran cepat",
        translationSl: "ක්ෂණික යෝජනා",
        translationNp: "द्रुत सुझावहरू",
        translationVn: "Gợi ý nhanh",
        translationPh: "Mabilisang mungkahi",
        translationBd: "দ্রুত পরামর্শ"
    },
    "Choose a manual year below, then send the question to search the maintenance manuals.": {
        translationEng: "Choose a manual year below, then send the question to search the maintenance manuals.",
        translationJp: "下の整備解説書の年度を選択してから質問を送信すると、整備解説書を検索できます。",
        translationIn: "Pilih tahun buku panduan di bawah, lalu kirim pertanyaan untuk mencari buku panduan perawatan.",
        translationSl: "පහත මාර්ගෝපදේශ වසරක් තෝරා, පසුව නඩත්තු මාර්ගෝපදේශ සෙවීමට ප්‍රශ්නය යවන්න.",
        translationNp: "तल म्यानुअल वर्ष चयन गर्नुहोस्, त्यसपछि रखरखाव म्यानुअल खोज्न प्रश्न पठाउनुहोस्।",
        translationVn: "Chọn năm sổ tay bên dưới, sau đó gửi câu hỏi để tìm kiếm trong sổ tay bảo trì.",
        translationPh: "Pumili ng taon ng manual sa ibaba, pagkatapos ay ipadala ang tanong upang hanapin sa maintenance manuals.",
        translationBd: "নিচে ম্যানুয়ালের বছর নির্বাচন করুন, তারপর রক্ষণাবেক্ষণ ম্যানুয়াল খুঁজতে প্রশ্নটি পাঠান।"
    },
    "Admin Dashboard": {
        translationEng: "Admin Dashboard",
        translationJp: "管理ダッシュボード",
        translationIn: "Dasbor Admin",
        translationSl: "පරිපාලක පුවරුව",
        translationNp: "प्रबन्धक ड्यासबोर्ड",
        translationVn: "Bảng điều khiển quản trị",
        translationPh: "Dashboard ng Admin",
        translationBd: "অ্যাডমিন ড্যাশবোর্ড"
    },
    "Back to Chat": {
        translationEng: "Back to Chat",
        translationJp: "チャットに戻る",
        translationIn: "Kembali ke Obrolan",
        translationSl: "කතාබහට ආපසු",
        translationNp: "च्याटमा फर्कनुहोस्",
        translationVn: "Quay lại Trò chuyện",
        translationPh: "Bumalik sa Chat",
        translationBd: "চ্যাটে ফিরে যান"
    },
    "Total Requests": {
        translationEng: "Total Requests",
        translationJp: "合計リクエスト",
        translationIn: "Total Permintaan",
        translationSl: "මුළු ඉල්ලීම්",
        translationNp: "कुल अनुरोधहरू",
        translationVn: "Tổng số yêu cầu",
        translationPh: "Kabuuang Kahilingan",
        translationBd: "মোট অনুরোধ"
    },
    "Pending": {
        translationEng: "Pending",
        translationJp: "保留中",
        translationIn: "Menunggu",
        translationSl: "විභාධනය",
        translationNp: "विचाराधीन",
        translationVn: "Đang chờ",
        translationPh: "Nakabinbin",
        translationBd: "অপেক্ষমান"
    },
    "Approved": {
        translationEng: "Approved",
        translationJp: "承認済み",
        translationIn: "Disetujui",
        translationSl: "අනුමත කරන ලදී",
        translationNp: "स्वीकृत",
        translationVn: "Đã phê duyệt",
        translationPh: "Naaprubahan",
        translationBd: "অনুমোদিত"
    },
    "Rejected": {
        translationEng: "Rejected",
        translationJp: "拒否されました",
        translationIn: "Ditolak",
        translationSl: "ප්‍රතික්ෂේප කරන ලදී",
        translationNp: "अस्वीकृत",
        translationVn: "Bị từ chối",
        translationPh: "Tinanggihan",
        translationBd: "প্রত্যাখ্যাত"
    },
    "Requests Over Time": {
        translationEng: "Requests Over Time (Last 7 Days)",
        translationJp: "リクエストの推移（過去7日間）",
        translationIn: "Permintaan Seiring Waktu (7 Hari Terakhir)",
        translationSl: "කාලය තුළ ඉල්ලීම් (පසුගිය දින 7)",
        translationNp: "समयसँग अनुरोधहरू (पछिल्ला ७ दिन)",
        translationVn: "Yêu cầu theo thời gian (7 ngày qua)",
        translationPh: "Mga Kahilingan sa Paglipas ng Panahon (Huling 7 Araw)",
        translationBd: "সময়ের সাথে অনুরোধ (গত ৭ দিন)"
    },
    "Request Distribution": {
        translationEng: "Request Distribution",
        translationJp: "リクエスト分布",
        translationIn: "Distribusi Permintaan",
        translationSl: "ඉල්ලීම් බෙදාහැරීම",
        translationNp: "अनुरोध वितरण",
        translationVn: "Phân phối yêu cầu",
        translationPh: "Distribusyon ng Kahilingan",
        translationBd: "অনুরোধ বিতরণ"
    },
    "Access Requests": {
        translationEng: "Access Requests",
        translationJp: "アクセスリクエスト",
        translationIn: "Permintaan Akses",
        translationSl: "ප්‍රවේශ ඉල්ලීම්",
        translationNp: "पहुँच अनुरोधहरू",
        translationVn: "Yêu cầu truy cập",
        translationPh: "Mga Kahilingan sa Pag-access",
        translationBd: "অ্যাক্সেস অনুরোধ"
    },
    "All": {
        translationEng: "All",
        translationJp: "すべて",
        translationIn: "Semua",
        translationSl: "සියල්ල",
        translationNp: "सबै",
        translationVn: "Tất cả",
        translationPh: "Lahat",
        translationBd: "সমস্ত"
    },
    "Error": {
        translationEng: "Error",
        translationJp: "エラー",
        translationIn: "Kesalahan",
        translationSl: "දෝෂයකි",
        translationNp: "त्रुटि",
        translationVn: "Lỗi",
        translationPh: "Error",
        translationBd: "ত্রুটি"
    },
    "The chatbot could not process this question. Please try again in a moment.": {
        translationEng: "The chatbot could not process this question. Please try again in a moment.",
        translationJp: "チャットボットがこの質問を処理できませんでした。しばらくしてからもう一度お試しください。",
        translationIn: "Chatbot tidak dapat memproses pertanyaan ini. Silakan coba lagi sebentar lagi.",
        translationSl: "චැට්බෝට් හට මෙම ප්‍රශ්නය සැකසීමට නොහැකි විය. කරුණාකර මොහොතකින් නැවත උත්සාහ කරන්න.",
        translationNp: "च्याटबटले यो प्रश्न प्रशोधन गर्न सकेन। कृपया केही बेरमा फेरि प्रयास गर्नुहोस्।",
        translationVn: "Chatbot không thể xử lý câu hỏi này. Vui lòng thử lại sau giây lát.",
        translationPh: "Hindi maproseso ng chatbot ang tanong na ito. Pakisubukan muli mamaya.",
        translationBd: "চ্যাটবট এই প্রশ্নটি প্রক্রিয়া করতে পারেনি। অনুগ্রহ করে কিছুক্ষণ পরে আবার চেষ্টা করুন।"
    },
    "Export CSV": {
        translationEng: "Export CSV",
        translationJp: "CSV出力",
        translationIn: "Ekspor CSV",
        translationSl: "CSV අපනයනය",
        translationNp: "CSV निर्यात",
        translationVn: "Xuất CSV",
        translationPh: "I-export ang CSV",
        translationBd: "CSV রপ্তানি"
    },
    "Date": {
        translationEng: "Date",
        translationJp: "日付",
        translationIn: "Tanggal",
        translationSl: "දිනය",
        translationNp: "मिति",
        translationVn: "Ngày",
        translationPh: "Petsa",
        translationBd: "তারিখ"
    },
    "Name": {
        translationEng: "Name",
        translationJp: "名前",
        translationIn: "Nama",
        translationSl: "නම",
        translationNp: "नाम",
        translationVn: "Tên",
        translationPh: "Pangalan",
        translationBd: "নাম"
    },
    "Email": {
        translationEng: "Email",
        translationJp: "メール",
        translationIn: "Email",
        translationSl: "ඊමේල්",
        translationNp: "इमेल",
        translationVn: "Email",
        translationPh: "Email",
        translationBd: "ইমেল"
    },
    "Company": {
        translationEng: "Company",
        translationJp: "会社",
        translationIn: "Perusahaan",
        translationSl: "සමාගම",
        translationNp: "कम्पनी",
        translationVn: "Công ty",
        translationPh: "Kumpanya",
        translationBd: "কোম্পানি"
    },
    "Branch": {
        translationEng: "Branch",
        translationJp: "支店",
        translationIn: "Cabang",
        translationSl: "ශාඛාව",
        translationNp: "शाखा",
        translationVn: "Chi nhánh",
        translationPh: "Sangay",
        translationBd: "শাখা"
    },
    "Status": {
        translationEng: "Status",
        translationJp: "ステータス",
        translationIn: "Status",
        translationSl: "තත්ත්වය",
        translationNp: "स्थिति",
        translationVn: "Trạng thái",
        translationPh: "Katayuan",
        translationBd: "স্থিতি"
    },
    "Actions": {
        translationEng: "Actions",
        translationJp: "操作",
        translationIn: "Tindakan",
        translationSl: "ක්‍රියා",
        translationNp: "कार्यहरू",
        translationVn: "Hành động",
        translationPh: "Mga Aksyon",
        translationBd: "ক্রিয়াকলাপ"
    },
    "Approve": {
        translationEng: "Approve",
        translationJp: "承認",
        translationIn: "Setuju",
        translationSl: "අනුමත කරන්න",
        translationNp: "स्वीकृत गर्नुहोस्",
        translationVn: "Phê duyệt",
        translationPh: "Aprubahan",
        translationBd: "অনুমোদন করুন"
    },
    "Approving": {
        translationEng: "Approving",
        translationJp: "承認中",
        translationIn: "Menyetujui",
        translationSl: "අනුමත කරමින්",
        translationNp: "स्वीकृत गर्दै",
        translationVn: "Đang phê duyệt",
        translationPh: "Nag-aapruba",
        translationBd: "অনুমোদন করা হচ্ছে"
    },
    "Post approved": {
        translationEng: "Post approved",
        translationJp: "投稿を承認しました",
        translationIn: "Posting disetujui",
        translationSl: "පළකිරීම අනුමත කර ඇත",
        translationNp: "पोस्ट स्वीकृत भयो",
        translationVn: "Đã phê duyệt bài đăng",
        translationPh: "Na-aprubahan na ang post",
        translationBd: "পোস্ট অনুমোদিত হয়েছে"
    },
    "Failed to approve": {
        translationEng: "Failed to approve",
        translationJp: "承認に失敗しました",
        translationIn: "Gagal menyetujui",
        translationSl: "අනුමත කිරීම අසාර්ථක විය",
        translationNp: "स्वीकृत गर्न असफल भयो",
        translationVn: "Phê duyệt thất bại",
        translationPh: "Nabigo ang pag-apruba",
        translationBd: "অনুমোদন ব্যর্থ"
    },
    "Error approving post": {
        translationEng: "Error approving post",
        translationJp: "投稿の承認中にエラーが発生しました",
        translationIn: "Kesalahan saat menyetujui posting",
        translationSl: "පළකිරීම අනුමත කිරීමේ දෝෂයක්",
        translationNp: "पोस्ट स्वीकृत गर्दा त्रुटि भयो",
        translationVn: "Lỗi khi phê duyệt bài đăng",
        translationPh: "Error sa pag-apruba ng post",
        translationBd: "পোস্ট অনুমোদনে ত্রুটি"
    },
    "Reject": {
        translationEng: "Reject",
        translationJp: "拒否",
        translationIn: "Tolak",
        translationSl: "ප්‍රතික්ෂේප කරන්න",
        translationNp: "अस्वीकार गर्नुहोस्",
        translationVn: "Từ chối",
        translationPh: "Tanggihan",
        translationBd: "প্রত্যাখ্যান করুন"
    },
    "No requests found": {
        translationEng: "No requests found",
        translationJp: "リクエストが見つかりません",
        translationIn: "Tidak ada permintaan ditemukan",
        translationSl: "ඉල්ලීම් හමු නොවීය",
        translationNp: "कुनै अनुरोध भेटिएन",
        translationVn: "Không tìm thấy yêu cầu",
        translationPh: "Walang nakitang kahilingan",
        translationBd: "কোন অনুরোধ পাওয়া যায়নি"
    },
    "Loading data": {
        translationEng: "Loading data...",
        translationJp: "データを読み込み中...",
        translationIn: "Memuat data...",
        translationSl: "දත්ත පූරණය වෙමින්...",
        translationNp: "डाटा लोड हुँदैछ...",
        translationVn: "Đang tải dữ liệu...",
        translationPh: "Naglo-load ng data...",
        translationBd: "ডাটা লোড হচ্ছে..."
    },
    "Showing": {
        translationEng: "Showing",
        translationJp: "表示中",
        translationIn: "Menampilkan",
        translationSl: "පෙන්වමින්",
        translationNp: "देखाउँदैछ",
        translationVn: "Đang hiển thị",
        translationPh: "Nagpapakita",
        translationBd: "দেখানো হচ্ছে"
    },
    "of": {
        translationEng: "of",
        translationJp: "の中",
        translationIn: "dari",
        translationSl: "න්",
        translationNp: "मध्ये",
        translationVn: "trong",
        translationPh: "sa",
        translationBd: "এর মধ্যে"
    },
    "Page": {
        translationEng: "Page",
        translationJp: "ページ",
        translationIn: "Halaman",
        translationSl: "පිටුව",
        translationNp: "पृष्ठ",
        translationVn: "Trang",
        translationPh: "Pahina",
        translationBd: "পৃষ্ঠা"
    },
    "Request Approval": {
        translationEng: "Request Approval",
        translationJp: "承認リクエスト",
        translationIn: "Permintaan Persetujuan",
        translationSl: "අනුමත ඉල්ලීම",
        translationNp: "अनुमोदन अनुरोध",
        translationVn: "Yêu cầu phê duyệt",
        translationPh: "Kahilingan ng Pag-apruba",
        translationBd: "অনুমোদনের অনুরোধ"
    },
    "Case study posts": {
        translationEng: "Case study posts",
        translationJp: "修理・トラブルシューティング事例",
        translationIn: "Posting studi kasus",
        translationSl: "අලුත්වැඩියා නඩු පළකිරීම්",
        translationNp: "केस अध्ययन पोस्टहरू",
        translationVn: "Bài đăng nghiên cứu tình huống",
        translationPh: "Mga post ng case study",
        translationBd: "কেস স্টাডি পোস্ট"
    },
    "Distributor posts": {
        translationEng: "Distributor posts",
        translationJp: "販社投稿",
        translationIn: "Posting distributor",
        translationSl: "බෙදාහරින්නාගේ පළකිරීම්",
        translationNp: "वितरक पोस्टहरू",
        translationVn: "Bài đăng của đại lý",
        translationPh: "Mga post ng distributor",
        translationBd: "ডিস্ট্রিবিউটর পোস্ট"
    },
    "View": {
        translationEng: "View",
        translationJp: "表示",
        translationIn: "Lihat",
        translationSl: "බලන්න",
        translationNp: "हेर्नुहोस्",
        translationVn: "Xem",
        translationPh: "Tingnan",
        translationBd: "দেখুন"
    },
    "Short ID": {
        translationEng: "Short ID",
        translationJp: "ショートID",
        translationIn: "ID Singkat",
        translationSl: "කෙටි හැඳුනුම",
        translationNp: "छोटो आईडी",
        translationVn: "ID ngắn",
        translationPh: "Maikling ID",
        translationBd: "সংক্ষিপ্ত আইডি"
    },
    "Users": {
        translationEng: "Users",
        translationJp: "ユーザー",
        translationIn: "Pengguna",
        translationSl: "පරිශීලකයින්",
        translationNp: "प्रयोगकर्ताहरू",
        translationVn: "Người dùng",
        translationPh: "Mga Gumagamit",
        translationBd: "ব্যবহারকারীরা"
    },
    "First Name": {
        translationEng: "First Name",
        translationJp: "名",
        translationIn: "Nama Depan",
        translationSl: "මුල් නම",
        translationNp: "पहिलो नाम",
        translationVn: "Tên",
        translationPh: "Unang Pangalan",
        translationBd: "প্রথম নাম"
    },
    "Last Name": {
        translationEng: "Last Name",
        translationJp: "姓",
        translationIn: "Nama Belakang",
        translationSl: "අවසාන නම",
        translationNp: "थर",
        translationVn: "Họ",
        translationPh: "Apelyido",
        translationBd: "শেষ নাম"
    },
    "User ID": {
        translationEng: "User ID",
        translationJp: "ユーザーID",
        translationIn: "ID Pengguna",
        translationSl: "පරිශීලක හැඳුනුම්පත",
        translationNp: "प्रयोगकर्ता आईडी",
        translationVn: "ID người dùng",
        translationPh: "ID ng User",
        translationBd: "ব্যবহারকারী আইডি"
    },
    "Department": {
        translationEng: "Department",
        translationJp: "部門",
        translationIn: "Departemen",
        translationSl: "දෙපාර්තමේන්තුව",
        translationNp: "विभाग",
        translationVn: "Phòng ban",
        translationPh: "Departamento",
        translationBd: "বিভাগ"
    },
    "Admin": {
        translationEng: "Admin",
        translationJp: "管理者",
        translationIn: "Admin",
        translationSl: "පරිපාලක",
        translationNp: "प्रबन्धक",
        translationVn: "Quản trị viên",
        translationPh: "Admin",
        translationBd: "অ্যাডমিন"
    },
    "Total": {
        translationEng: "Total",
        translationJp: "合計",
        translationIn: "Total",
        translationSl: "මුළු",
        translationNp: "कुल",
        translationVn: "Tổng",
        translationPh: "Kabuuan",
        translationBd: "মোট"
    },
    "Loading users": {
        translationEng: "Loading users...",
        translationJp: "ユーザーを読み込み中...",
        translationIn: "Memuat pengguna...",
        translationSl: "පරිශීලකයින් පූරණය වෙමින්...",
        translationNp: "प्रयोगकर्ताहरू लोड हुँदैछ...",
        translationVn: "Đang tải người dùng...",
        translationPh: "Naglo-load ng mga user...",
        translationBd: "ব্যবহারকারীরা লোড হচ্ছে..."
    },
    "No users found": {
        translationEng: "No users found",
        translationJp: "ユーザーが見つかりません",
        translationIn: "Tidak ada pengguna ditemukan",
        translationSl: "පරිශීලකයින් හමු නොවීය",
        translationNp: "कुनै प्रयोगकर्ता भेटिएन",
        translationVn: "Không tìm thấy người dùng",
        translationPh: "Walang nakitang user",
        translationBd: "কোন ব্যবহারকারী পাওয়া যায়নি"
    },
    "Yes": {
        translationEng: "Yes",
        translationJp: "はい",
        translationIn: "Ya",
        translationSl: "ඔව්",
        translationNp: "हो",
        translationVn: "Có",
        translationPh: "Oo",
        translationBd: "হ্যাঁ"
    },
    "No": {
        translationEng: "No",
        translationJp: "いいえ",
        translationIn: "Tidak",
        translationSl: "නැත",
        translationNp: "होइन",
        translationVn: "Không",
        translationPh: "Hindi",
        translationBd: "না"
    },
    "Create User": {
        translationEng: "Create User",
        translationJp: "ユーザーを作成",
        translationIn: "Buat Pengguna",
        translationSl: "පරිශීලකයා සාදන්න",
        translationNp: "प्रयोगकर्ता सिर्जना गर्नुहोस्",
        translationVn: "Tạo người dùng",
        translationPh: "Lumikha ng User",
        translationBd: "ব্যবহারকারী তৈরি করুন"
    },
    "Create": {
        translationEng: "Create",
        translationJp: "作成",
        translationIn: "Buat",
        translationSl: "සාදන්න",
        translationNp: "सिर्जना गर्नुहोस्",
        translationVn: "Tạo",
        translationPh: "Lumikha",
        translationBd: "তৈরি করুন"
    },
    "Cancel": {
        translationEng: "Cancel",
        translationJp: "キャンセル",
        translationIn: "Batal",
        translationSl: "අවලංගු කරන්න",
        translationNp: "रद्द गर्नुहोस्",
        translationVn: "Hủy",
        translationPh: "Kanselahin",
        translationBd: "বাতিল করুন"
    },
    "User created successfully": {
        translationEng: "User created successfully",
        translationJp: "ユーザーが正常に作成されました",
        translationIn: "Pengguna berhasil dibuat",
        translationSl: "පරිශීලකයා සාර්ථකව සාදන ලදී",
        translationNp: "प्रयोगकर्ता सफलतापूर्वक सिर्जना गरियो",
        translationVn: "Người dùng đã được tạo thành công",
        translationPh: "Matagumpay na nalikha ang user",
        translationBd: "ব্যবহারকারী সফলভাবে তৈরি হয়েছে"
    },
    "Failed to load distributor posts": {
        translationEng: "Failed to load distributor posts",
        translationJp: "販社投稿の読み込みに失敗しました",
        translationIn: "Gagal memuat posting distributor",
        translationSl: "බෙදාහරින්නාගේ පළකිරීම් ලබා ගැනීම අසාර්ථක විය",
        translationNp: "वितरक पोस्टहरू लोड गर्न असफल भयो",
        translationVn: "Không thể tải bài đăng của đại lý",
        translationPh: "Nabigo ang pag-load ng mga post ng distributor",
        translationBd: "ডিস্ট্রিবিউটর পোস্ট লোড করতে ব্যর্থ"
    },
    "Failed to create user": {
        translationEng: "Failed to create user",
        translationJp: "ユーザーの作成に失敗しました",
        translationIn: "Gagal membuat pengguna",
        translationSl: "පරිශීලකයා සෑදීම අසාර්ථක විය",
        translationNp: "प्रयोगकर्ता सिर्जना गर्न असफल भयो",
        translationVn: "Không thể tạo người dùng",
        translationPh: "Nabigo ang paglikha ng user",
        translationBd: "ব্যবহারকারী তৈরি করতে ব্যর্থ হয়েছে"
    },
    "Creating user": {
        translationEng: "Creating user...",
        translationJp: "ユーザーを作成中...",
        translationIn: "Membuat pengguna...",
        translationSl: "පරිශීලකයා සාදමින්...",
        translationNp: "प्रयोगकर्ता सिर्जना गर्दै...",
        translationVn: "Đang tạo người dùng...",
        translationPh: "Lumilikha ng user...",
        translationBd: "ব্যবহারকারী তৈরি করা হচ্ছে..."
    },
    "Manual Coverage": {
        translationEng: "Manual Coverage",
        translationJp: "整備解説書の対象範囲",
        translationIn: "Cakupan Buku Panduan",
        translationSl: "අත්පොත් ආවරණය",
        translationNp: "म्यानुअल कभरेज",
        translationVn: "Phạm vi sổ tay",
        translationPh: "Saklaw ng Manual",
        translationBd: "ম্যানুয়াল কভারেজ"
    },
    "Maintenance manual coverage by model": {
        translationEng: "Maintenance manual coverage by model",
        translationJp: "モデル別 整備解説書の対象範囲",
        translationIn: "Cakupan buku panduan perawatan per model",
        translationSl: "මාදිලිය අනුව නඩත්තු අත්පොත් ආවරණය",
        translationNp: "मोडेल अनुसार रखरखाव म्यानुअल कभरेज",
        translationVn: "Phạm vi sổ tay bảo trì theo mẫu xe",
        translationPh: "Saklaw ng maintenance manual ayon sa modelo",
        translationBd: "মডেল অনুযায়ী রক্ষণাবেক্ষণ ম্যানুয়াল কভারেজ"
    },
    "Pick the manual year that matches your vehicle, using the chassis number range below.": {
        translationEng: "Pick the manual year that matches your vehicle, using the chassis number range below.",
        translationJp: "下記の車台番号の範囲を参考に、お使いの車両に合った整備解説書の年度を選択してください。",
        translationIn: "Pilih tahun buku panduan yang sesuai dengan kendaraan Anda berdasarkan rentang nomor sasis di bawah.",
        translationSl: "පහත චැසි අංක පරාසය භාවිතයෙන් ඔබේ වාහනයට ගැළපෙන අත්පොත් වසර තෝරන්න.",
        translationNp: "तलको चेसिस नम्बर दायरा हेरेर आफ्नो सवारीसँग मिल्ने म्यानुअल वर्ष छान्नुहोस्।",
        translationVn: "Chọn năm sổ tay phù hợp với xe của bạn theo dải số khung bên dưới.",
        translationPh: "Piliin ang taon ng manual na tugma sa iyong sasakyan gamit ang saklaw ng chassis number sa ibaba.",
        translationBd: "নিচের চেসিস নম্বরের পরিসর দেখে আপনার গাড়ির সাথে মেলে এমন ম্যানুয়ালের বছর বেছে নিন।"
    }
};
